// src/components/Profile/ProfileButtons.js

import React from "react";
import { useNavigate } from "react-router-dom"; // Para navegación entre rutas
import { cn } from "../lib/utils";

const tabClass = (active) =>
  cn(
    "rounded-md px-4 py-2 text-sm font-medium transition-colors",
    active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted"
  );

const ProfileButtons = ({ isOwner, activeTab, setActiveTab }) => {
  const navigate = useNavigate(); // Navegar entre rutas
  return (
    <div className="flex flex-wrap gap-2 border-b border-border pb-4">
      <button className={tabClass(activeTab === "perfil")} onClick={() => setActiveTab("perfil")}>
        Perfil
      </button>
      <button className={tabClass(activeTab === "reviews")} onClick={() => setActiveTab("reviews")}>
        Reseñas
      </button>
      {isOwner && (
        <button className={tabClass(false)} onClick={() => navigate("/mis-licitaciones")}>
          Mis Licitaciones
        </button>
      )}
    </div>
  );
};

export default ProfileButtons;
